<script setup lang="ts">
import type { NuxtError } from '#app'

const props = defineProps<{ error: NuxtError }>()
const status = computed(() => props.error.statusCode || 500)
const copy = computed(() =>
  status.value === 403
    ? {
        eyebrow: '403',
        title: 'Permission insuffisante',
        text: 'Vous ne disposez pas des droits nécessaires pour cette action.',
      }
    : status.value === 404
      ? {
          eyebrow: '404',
          title: 'Page introuvable',
          text: 'Cette page est introuvable ou son accès est limité.',
        }
      : {
          eyebrow: String(status.value),
          title: 'Morning est indisponible',
          text: 'Une erreur empêche momentanément l’affichage. Réessayez dans quelques instants.',
        },
)
function back() {
  if (history.length > 1) history.back()
  else void navigateTo('/')
}
</script>

<template>
  <div class="morning-shell">
    <main class="error-page">
      <div class="error-card">
        <img
          src="/morning-mark.svg"
          alt=""
          width="52"
          height="52"
        />
        <p class="error-eyebrow">{{ copy.eyebrow }}</p>
        <h1>{{ copy.title }}</h1>
        <p>{{ copy.text }}</p>
        <div class="admin-form-actions">
          <UiButton
            variant="outline"
            tone="neutral"
            type="button"
            @click="back"
          >
            Retour précédent</UiButton
          ><NuxtLink
            class="retry-button"
            to="/"
            @click="clearError()"
            >Retour à Morning</NuxtLink
          >
        </div>
      </div>
    </main>
  </div>
</template>
